import React, { Component } from 'react'
import {Redirect} from 'react-router-dom'
import AWSAPI from '../../../common/AWSAPI'
import Window from '../../../common/Window'
import Config from '../../../Config'

class CommonLogin extends Component {
  constructor (props) {
    super(props)
    this.state = {email: '', password: '', redirectTo: ''}
  }
  validate (username, password) {
    const requiredErrors = []
    if (username === '') {
      requiredErrors.push('メールアドレス')
    }
    if (password === '') {
      requiredErrors.push('パスワード')
    }
    if (requiredErrors.length > 0) {
      Window.alert(requiredErrors.join('、') + 'は必須です')
      return false
    }
    return true
  }
  login (e) {
    e.preventDefault()
    const username = this.state.email.trim()
    const password = this.state.password.trim()
    if (!this.validate(username, password)) {
      return false
    }
    const onSuccess = (authresult) => {
      const apiUrl = Config[this.userRole + 'ApiUrl'].actionLog
      AWSAPI.writeActionLog(this.userRole, apiUrl, 'Login', () => {
        window.location.reload()
      })
    }
    const onFailure = (err) => {
      if (err) {
        Window.alert('ログインの処理に失敗しました')
        // console.log(err.message)  //デバッグ時以外はコメントアウト
      }
    }
    const newPasswordRequired = (userAttributes, requiredAttributes, cognitoUser, onSuccess, onFailure) => {
      Window.prompt('新しいパスワードを英数字か次の半角記号（!#_&@）の組み合わせ\n8文字以上で入力してください\n\nこのパスワードはお問い合わせでもお答えできませんので、\n必ずどこかにメモしてください',
      (newPassword) => {
        if (newPassword.length < 8 || !newPassword.match(/^[a-z\d!#_&@]{8,256}$/i)) {
          return '正しい形式で入力してください'
        } else {
          cognitoUser.completeNewPasswordChallenge(newPassword.trim(), null, {
            onSuccess: onSuccess,
            onFailure: onFailure
          })
          Window.closeDialog()
          return ''
        }
      })
    }
    const onSuccessToChangeTemporaryPassword = (authresult) => {
      Window.alert('パスワードを変更しました', () => {
        window.location.href = '/' + this.userRoleUrl + '/login'
        Window.closeDialog()
      })
    }
    AWSAPI.authenticateUser(this.userRole, username, password, onSuccess, onFailure, newPasswordRequired, onSuccessToChangeTemporaryPassword)
  }
  render () {
    if ('localStorage' in window) {
      window.localStorage.clear()
    }
    if ('sessionStorage' in window) {
      window.sessionStorage.clear()
    }
    if (this.state.redirectTo) {
      return <Redirect to={this.state.redirectTo} />
    }
    const changed = (name, e) => this.setState({[name]: e.target.value})
    return (
      <div id='body-container'>
        <div id='body-content'>
          <div className='container'>
            <div className='signin-row'>
              <div className='logo'><img src='/images/logo.png' alt='ロゴ' /><span>{this.loginFormTitle}</span></div>
              <div className='well well-small well-shadow'>
                <legend>ログイン</legend>
                <form method='POST' className='form-signin' autoComplete='off'>
                  <div className='input-prepend'>
                    <span className='add-on' rel='tooltip' title='Username or E-Mail Address' data-placement='top'><i className='icon-envelope' />Ｅメール</span>
                    <input type='text' className='span4' id='username' ref='email' value={this.state.email} onChange={e => changed('email', e)} />
                  </div>
                  <div className='input-prepend'>
                    <span className='add-on'><i className='icon-key' />パスワード</span>
                    <input type='password' className='span4' id='password' ref='password' value={this.state.password} onChange={e => changed('password', e)} />
                  </div>
                  <footer className='signin-actions'>
                    <input className='btn btn-primary' type='submit' id='submit' value='ログイン' onClick={e => this.login(e)} />
                  </footer>
                  <div className='text-center' style={{marginTop: '10px'}}>
                    <a href={'/' + this.userRoleUrl + '/password_reset'}>パスワードを忘れた方はこちら</a>
                  </div>
                </form>
              </div>
            </div>
            <div className='signin-row'>
              <div className='well well-small well-shadow'>
                <legend className='lead'>使用上の注意</legend>
                <p className='text-caution'>このシステムの対応ブラウザ(*1)は、Chromeです。<br />
                他のブラウザでの動作は保証しておりません。</p>
                <p className='text-underline'><a target='_blank' href='https://www.google.com/chrome/browser/desktop/index.html'>こちらから最新のChromeをダウンロードしてご利用ください。</a></p>
                <p className='text-small'> *1 ブラウザとは、Chrome、Internet Explorer、Firefox、Safariなどのインターネット上のサイトを閲覧する際に使用するプログラムのことです</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CommonLogin



// WEBPACK FOOTER //
// ./src/common/pages/public/Login.js